import { jsxs, jsx } from "react/jsx-runtime";
const IconSentimentSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 23C5.935 23 1 18.065 1 12S5.935 1 12 1s11 4.935 11 11-4.935 11-11 11Zm0-20c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9Z" }),
      /* @__PURE__ */ jsx("circle", { cx: 9.5, cy: 9.5, r: 1.5 }),
      /* @__PURE__ */ jsx("circle", { cx: 14.5, cy: 9.5, r: 1.5 }),
      /* @__PURE__ */ jsx("path", { d: "M16 17H8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2Z" })
    ]
  }
);
export {
  IconSentimentSvg
};
